
import { CONFERENCE_JOINED, CONFERENCE_FAILED, setPassword } from '../base/conference';
import { PREJOIN_START_CONFERENCE } from "./actionTypes";

import { updateConfig } from '../base/config';
import { updateSettings } from '../base/settings';

import {
    getLocalTracks,
    replaceLocalTrack,
    TRACK_ADDED,
    TRACK_NO_DATA_FROM_SOURCE
} from '../base/tracks';
import {
    setPrejoinPageVisibility
} from './actions';
import { hideDialog } from '../base/dialog';
import { toggleLobbyMode } from '../lobby/actions.web';
import { JitsiConferenceErrors } from '../base/lib-jitsi-meet';
import { PasswordRequiredPrompt, RoomLockPrompt } from '../room-lock/components';
import { PARTICIPANT_UPDATED } from '../base/participants';

declare var APP: Object;
declare var socket: Object;
declare var User: Object;

export async function RPC_PrejoinMiddleware(store, next, action) {
    switch (action.type) {
        case CONFERENCE_JOINED: {
            const { getState, dispatch } = store;
            const conference = getState()['features/base/conference'];
            function joinRoom() {
                socket.emit('join', {
                    id: conference.room,
                    name: conference.meeting.name,
                    media_server: config.deploymentInfo.userRegion,
                    domain: JSON.parse(localStorage.latency || `[{server: '', latency: ''}]`).sort((a, b) => a.latency - b.latency)[0].server,
                    latency: JSON.parse(localStorage.latency || `[{server: '', latency: ''}]`).sort((a, b) => a.latency - b.latency)[0].latency
                }, {
                    id: window.User.id || APP.conference.getMyUserId(),
                    socket_id: socket.id,
                    name: getState()['features/base/participants'].local.name
                });
            }
            joinRoom();
            socket.on('connect', joinRoom);
            // dispatch(setPrejoinPageVisibility(false));
            break;
        }
        case PARTICIPANT_UPDATED: {
            const { getState, dispatch } = store;
            if(action.participant && action.participant.role == 'moderator' && action.participant.id == APP.conference.getMyUserId()) {
                const { conference, password } = getState()['features/base/conference'];
                const { lobbyEnabled } = getState()['features/lobby'];
                if(lobbyEnabled) {
                    dispatch(toggleLobbyMode(true));
                } if (password) {
                    dispatch(setPassword(conference, conference.lock, password));
                }
            }
            break;
        }
        // case CONFERENCE_FAILED: {
        //     _conferenceFailed(store, next, action);
        //     break;
        // }
        case PREJOIN_START_CONFERENCE: {
            break;
            const { getState, dispatch } = store;
            const state = getState();
            const { userSelectedSkipPrejoin } = state['features/prejoin'];
            const localTracks = getLocalTracks(state['features/base/tracks']);
            const { options } = action;
    
            options && store.dispatch(updateConfig(options));
    
            userSelectedSkipPrejoin && dispatch(updateSettings({
                userSelectedSkipPrejoin
            }));
    
            // Do not signal audio/video tracks if the user joins muted.
            for (const track of localTracks) {
                if (track.muted) {
                    await dispatch(replaceLocalTrack(track.jitsiTrack, null));
                }
            }
            const jitsiTracks = localTracks.map(t => t.jitsiTrack);

            APP.conference.prejoinStart(jitsiTracks);
    
            break;
        }
    }
    
    return next(action);
}

function _conferenceFailed({ getState, dispatch }, next, action) {
    const { conference, error } = action;

    if (conference && error.name === JitsiConferenceErrors.PASSWORD_REQUIRED) {
        // XXX The feature room-lock affords recovery after CONFERENCE_FAILED
        // caused by JitsiConferenceErrors.PASSWORD_REQUIRED.
        if (typeof error.recoverable === 'undefined') {
            error.recoverable = true;
        }
        if (error.recoverable) {
            (function passwordRequired() {
                if(!window.lobby_password) { return; }
                if(getState()['features/base/conference'].passwordRequired) {
                    dispatch(setPassword(
                        conference,
                        conference.join,
                        window.lobby_password
                    ));
                    delete window.lobby_password;
                } else {
                    setTimeout(passwordRequired, 100);
                }
            }());
        }
    } else {
        dispatch(hideDialog(PasswordRequiredPrompt));
        dispatch(hideDialog(RoomLockPrompt));
    }
}